
import { MetalPrice } from '@/lib/metal-price';

export function calculateMinPrice(prices: MetalPrice[]): number | null {
  if (!prices || prices.length === 0) return null;
  
  const validPrices = prices.filter(p => p && typeof p.price === 'number' && !isNaN(p.price));
  if (validPrices.length === 0) return null;
  
  return Math.min(...validPrices.map(p => p.price));
}

export function calculateMaxPrice(prices: MetalPrice[]): number | null {
  if (!prices || prices.length === 0) return null;
  
  const validPrices = prices.filter(p => p && typeof p.price === 'number' && !isNaN(p.price));
  if (validPrices.length === 0) return null;
  
  return Math.max(...validPrices.map(p => p.price));
}

export function calculateAveragePrice(prices: MetalPrice[]): number | null {
  if (!prices || prices.length === 0) return null;
  
  const validPrices = prices.filter(p => p && typeof p.price === 'number' && !isNaN(p.price));
  if (validPrices.length === 0) return null;
  
  const sum = validPrices.reduce((acc, p) => acc + p.price, 0);
  return sum / validPrices.length;
}

export function formatPrice(price: number | null): string {
  if (price === null) return 'N/A';
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
}
